module.exports = __webpack_public_path__ + "static/media/fa-brands-400.3f5a250e.ttf";